//@ts-check

class Scrollable {
	constructor($window, $templateCache) {
		this.scope = {
			mainTarget: '@'
		};
		this.restrict = 'A';
		this.$window = $window;
		this.link = this.ScrollableLink;
		this.template = this.templateString;
		this.$templateCache = $templateCache;
	}

	init() {
		/*
		this.$items = null;
		this.$element = null;
		this.selectorRaw = null;
		*/

		this.animDuration = 600;
		this.winWidth = this.$win.width();
		this.$win = angular.element(this.$window);
		this.scrollWidth = this.$li.outerWidth(true) * 2;
		this.$next = angular.element('.next', this.$element);
		this.$prev = angular.element('.prev', this.$element);
		this.$li = angular.element('li:first-child', this.$element);
		this.$menu = angular.element('ul:first-child', this.$element);

		if (this.winWidth > 521) {
			this.showStretched();
			return;
		}

		if (!(this.$items && this.$items.length > 0)) {
			const $container = this.$element.closest(this.selectorRaw);
			this.$items = angular.element('.scrollable', $container);
		}
	}

	get templateString() {
		return `<a class="prev" href="#">
					<i class="fas fa-angle-left"></i>
				</a>
				<div class="scrollable-ctrl" ng-transclude>
				</div>
				<a class="next" href="#">
					<i class="fas fa-angle-right"></i>
				</a>
		`;
	}

	showStretched() {
		this.hideArrows();
	}

	hideArrows() {
		this.$next.css('display', 'none');
		this.$prev.css('display', 'none');
	}

	showArrow() {
		this.$next.css('display', 'inline');
		this.$prev.css('display', 'inline');
	}

	setHandlersPosition() {
		let top = 0;
		this.showArrow();
		this.$prev.css('top', `${top}em`);
		this.$next.css('top', `${top}em`);
		this.$next.css('left', `${this.winWidth - 77.5}px`);
		this.$next.css('height', `${this.$li.outerHeight(true)} px`);
		this.$prev.css('height', `${this.$li.outerHeight(true)} px`);
	}

	setScrollableSize(size) {
		const offsetTag = angular.element('burger-menu .hamburger');
		const offset = offsetTag.length > 0 ? offsetTag.outerWidth() : 0;
		const scrollableWidth = size || this.winWidth - offset;

		this.$menu.width(scrollableWidth);
	}

	ScrollableLink(scope, element, attrs) {
		this.$element = angular.element(element);
		const $container = this.$element.closest(this.selectorRaw);
		this.$items = angular.element('.scrollable', $container);
		this.selectorRaw = (attrs.mainTarget || '').toString().toLowerCase();

		this.init();

		this.$prev.on('click', (evt) => {
			evt.preventDefault();
			this.scroll(-1);
		});

		this.$next.on('click', (evt) => {
			evt.preventDefault();
			this.scroll(1);
		});

		this.$win.on('resize', () => {
			this.winWidth = this.$win.width();
			if (this.winWidth > 521) {
				this.showStretched();
				return;
			}
			//setHandlersPosition();
		});
	}

	scroll(direction, length) {
		const leftWidth = this.scrollWidth * direction;
		const scrollValue = this.$element.scrollLeft() + leftWidth + (length || 0);

		this.$items.animate({ scrollLeft: scrollValue }, this.animDuration);
	}
}

export default /* @ngInject */ ($window, $templateCache) => new Scrollable($window, $templateCache);
